import { DiscountTypes } from "@/common/enums";

export default class LatPayStationSettingsModel {
    stationId: string = "";
    deviceId: string = "";
    terminalSecret: string = "";
    terminalReference: string = "";
    responseSecret: string = "";

    static from(json: string): LatPayStationSettingsModel {
        let model = Object.assign(new LatPayStationSettingsModel(), json);
        return model;
    }
}
